import { createSelector, createSlice } from '@reduxjs/toolkit';

import { LoadingState } from '@nocowanie/core/enums';

import { SliceNameEnum } from '@app/enums';
import { MapAccommodationModel } from '@app/models/elastic-search';
import { getAccommodationForMap } from '@app/state/api-thunks/map-accommodation.thunk';

type MapAccommodationState = {
    data: Record<string, MapAccommodationModel>;
    loading: LoadingState;
    errors?: unknown;
};

const initialState: MapAccommodationState = {
    data: {},
    loading: LoadingState.IDLE,
};

const slice = createSlice({
    name: SliceNameEnum.MapAccommodation,
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getAccommodationForMap.pending, state => {
            state.loading = LoadingState.PENDING;
        });
        builder.addCase(getAccommodationForMap.fulfilled, (state, { payload }) => {
            state.loading = LoadingState.IDLE;
            state.errors = null;
            state.data[payload.id] = payload.data;
        });
        builder.addCase(getAccommodationForMap.rejected, (state, action) => {
            state.loading = LoadingState.IDLE;

            if (typeof action.payload === 'string') {
                state.errors = action.payload;
            } else if (action.error?.message) {
                state.errors = action.error.message;
            } else {
                state.errors = 'Unknown error';
            }
        });
    },
});

// Selectors
const selectSelfState = (state: { [SliceNameEnum.MapAccommodation]: MapAccommodationState }) =>
    state[SliceNameEnum.MapAccommodation] ?? initialState;

const selectors = {
    selectAccommodationById: (id: string) =>
        createSelector(selectSelfState, state => state.data[id]),
    selectLoading: createSelector(selectSelfState, state => state.loading),
    selectErrors: createSelector(selectSelfState, state => state.errors),
};

const actions = {
    getAccommodationForMap,
};

export { slice, actions, selectors, initialState };
